import { useEffect, useState, useRef } from "react";
import { Spinner, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Preloader from "@/components/Elements/Preloader";
import SuperTrackMarkupVideo from "./SuperTrackMarkupVideo";
import { useParams } from "react-router-dom";
import { matchApi } from "../../api";
import SuperTrackMarkupPanel from "./SuperTrackMarkupPanel";
import { VideoRangeInput } from "./SuperTrackTime";
import { VideoTimeProvider } from "./VideoTimeContext";
import "./SuperTrackMarkup.scss";
import { toast } from "react-toastify";
import { generateSuperTrackMapV2, createTracksMapV2 } from "@/util/functions";
import {
  setFps,
  setFrameBoxes,
  setSuperTracks,
  setTracksMap,
  updateMatch,
  updateSelectedTracks,
} from "@/store/supertrackSlice";

export default function SuperTracks() {
  const { videoId } = useParams();
  const dispatch = useDispatch();
  const { match, superTracks } = useSelector(
    ({ superTracks }) => superTracks
  );
  const posRef = useRef();
  const [isTracksLoaded, setIsTracksLoaded] = useState(false);
  const [frameStep, setFrameStep] = useState(1);
  const [error, setError] = useState(null);
  const [isReloading, setIsReloading] = useState(false);

  const storagedVideoId = localStorage.getItem("videoId");

  if (storagedVideoId !== videoId) {
    const selectedTracksFromStorage = JSON.parse(
      localStorage.getItem("selectedTrackBoxes")
    );

    localStorage.setItem("videoId", videoId);
    localStorage.setItem("selectedSupertracks", null);
    localStorage.setItem("superTrackTeams", null);
    localStorage.setItem("selectedTrackBoxes", JSON.stringify([]));

    dispatch(
      updateSelectedTracks({ isAdding: true, ids: selectedTracksFromStorage })
    );
  }

  const fetchSuperTracksData = async () => {
    if (!videoId) return;
    
    setIsReloading(true);
    setError(null);
    
    try {
      const { frame_step, supertracks, tracks } =
        await matchApi.getMatchSuperTracksFull(videoId);
      if (!tracks) toast.error("There are no tracks in the file.");

      dispatch(setFrameBoxes(tracks));
      if (frame_step) setFrameStep(frame_step);

      dispatch(setSuperTracks(generateSuperTrackMapV2(supertracks)));
      dispatch(setTracksMap(createTracksMapV2(supertracks)));

      setIsTracksLoaded(true);
    } catch (error) {
      console.log("error2", error);
      setError(error);
    } finally {
      setIsReloading(false);
    }
  };

  useEffect(() => {
    if (!videoId) return;

    async function fetchMatchInfo() {
      try {
        matchApi
          .getMatch(videoId)
          .then((match) => {
            if (!match) return;
            dispatch(updateMatch(match));
            const { fps } = match.video;
            dispatch(setFps(fps));
          })
          .catch((error) => {
            console.log("error1", error);
            setError(error);
          });

        await fetchSuperTracksData();
      } catch (error) {
        console.log("error2", error);
        setError(error);
      }
    }

    fetchMatchInfo();
  }, [videoId]);

  if (!match) {
    return <Preloader className="m-auto" />;
  }

  return (
    <div className="super-track__page-container">
      <VideoTimeProvider>
        <SuperTrackMarkupVideo posRef={posRef} frameStep={frameStep} />
        <VideoRangeInput />
        {superTracks && isTracksLoaded && !error ? (
          <SuperTrackMarkupPanel ref={posRef} />
        ) : error ? (
          <div className="tw-w-full tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-4 tw-p-8">
            <div className="tw-text-center">
              <h4 className="tw-text-red-600 tw-mb-2">Failed to load tracks data</h4>
              <p className="tw-text-gray-600 tw-mb-4">{error.message}</p>
            </div>
            <Button 
              variant="primary" 
              onClick={fetchSuperTracksData}
              disabled={isReloading}
            >
              {isReloading ? (
                <>
                  <Spinner animation="border" size="sm" className="tw-mr-2" />
                  Reloading...
                </>
              ) : (
                'Reload Tracks Data'
              )}
            </Button>
          </div>
        ) : (
          <div className="tw-w-full tw-flex tw-justify-center tw-items-center">
            <Spinner animation="border" role="status" />
          </div>
        )}
      </VideoTimeProvider>
    </div>
  );
}
